export const WebSocketMessages = {
	Login: 'login',
  Search: {
    Create: 'create search',
    Removed: 'removed search',
    Updated: 'updated search'
  },
  Analytics: {
    Start: 'start analytics',
    Finished: 'finished analytics',
    Failed: 'failed analytics'
  }
}